import {connect} from 'react-redux';
import AccountCreated from './AccountCreated.jsx';
import {
  handleResendEmailClick
} from './actions';

const mapStateToProps = (state) => {
  let addressBase =  window.location.href.substring(window.location.origin.length, window.location.href.indexOf('/registration/accountCreated')) ;

  // This is needed for development testing. 
  if (addressBase == "0") addressBase = "";

  return ({
    displayGoHome: state.registration.accountCreated.displayGoHome,
    addressBase: addressBase
  });
};

const mapDispatchToProps = dispatch => ({
    onResendEmailClick: () => dispatch(handleResendEmailClick())
  });

export default connect(mapStateToProps, mapDispatchToProps)(AccountCreated);



// WEBPACK FOOTER //
// ./src/features/registration/accountCreated/AccountCreatedContainer.jsx